import Router from './js/util/Router';
import common from './js/routes/common';
import home from './js/routes/home';
import pageTemplatePageProdotti from './js/routes/pageTemplatePageProdotti';
import pageTemplatePageProdottiGamma from './js/routes/pageTemplatePageProdottiGamma';
import pageTemplatePageStoria from './js/routes/pageTemplatePageStoria';
import pageTemplatePageFavola from './js/routes/pageTemplatePageFavola';
import pageTemplatePageContatti from './js/routes/pageTemplatePageContatti';
import pageTemplatePageNews from './js/routes/pageTemplatePageNews';
import single from './js/routes/single';
import singleProdotto from './js/routes/singleProdotto';
import singleRicetta from './js/routes/singleRicetta';
import pageTemplatePageIlnostroimpegno from './js/routes/pageTemplatePageIlnostroimpegno';
import pageTemplatePageRicetta from './js/routes/pageTemplatePageRicetta';
import pageTemplatePageLavoraconnoi from './js/routes/pageTemplatePageLavoraconnoi';

import './scss/application.scss';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
	/** Page Template Storia */
	pageTemplatePageStoria,
	/** Page Template Prodotti */
	pageTemplatePageProdotti,
	/** Page Template Prodotti - Gamma*/
	pageTemplatePageProdottiGamma,
	/** Page Template Favola */
	pageTemplatePageFavola,
	/** Page Template Contatti */
	pageTemplatePageContatti,
	/** Page Template News */
	pageTemplatePageNews,
	/** Single page */
	single,
	/** Single Product page */
	singleProdotto,
	/** Single Ricetta page */
	singleRicetta,
	/** Page Template Impegno */
	pageTemplatePageIlnostroimpegno ,
	/** Page Template Ricetta */
	pageTemplatePageRicetta ,
	/** Page Template Lavora */
	pageTemplatePageLavoraconnoi ,
});

/** Load Events */
jQuery(document).ready(() => {
	routes.loadEvents()
});
